import { Permission } from '@insio/shared-types';
import { usePermissions } from '@/features/auth';
import type { BankAccountPermissions } from '../utils/bank-account-actions';

/** Who may manage bank accounts (PARTIES_MANAGE) and who may sign them (BANK_ACCOUNTS_VERIFY). */
export function useBankAccountPermissions(): BankAccountPermissions {
  const { hasPermission } = usePermissions();
  return {
    canManage: hasPermission(Permission.PARTIES_MANAGE),
    canVerify: hasPermission(Permission.BANK_ACCOUNTS_VERIFY)
  };
}
